import { useMemo } from "react";

const useStyle = (isMobile: boolean) => {
  const classes = useMemo(() => {
    return {
      paginationStyle: {
        display: "flex",
        width: "100%",
        // Keeps the controls inside a phone viewport; desktop keeps its original box model.
        ...(isMobile
          ? {
              maxWidth: "100%",
              boxSizing: "border-box" as const,
              overflowX: "hidden" as const,
            }
          : {}),
        flexDirection: isMobile ? ("column" as "column") : ("row" as "row"),
        alignItems: "center",
        justifyContent: isMobile
          ? ("center" as "center")
          : ("space-between" as "space-between"),
        gap: isMobile ? 4 : 0,
        paddingLeft: isMobile ? 8 : 20,
        paddingRight: isMobile ? 8 : 20,
        paddingTop: isMobile ? 4 : 0,
        paddingBottom: isMobile
          ? ("calc(4px + env(safe-area-inset-bottom))" as any)
          : 0,
        flexShrink: 0,
      },
      selectsContainerStyle: {
        display: "flex",
        flexDirection: "row" as "row",
        alignItems: "center",
        justifyContent: isMobile
          ? ("center" as "center")
          : ("flex-end" as "flex-end"),
        flexWrap: "nowrap" as "nowrap",
        gap: isMobile ? 12 : 0,
        width: isMobile ? "100%" : "auto",
        ...(isMobile ? { maxWidth: "100%" } : {}),
      },
    };
  }, [isMobile]);
  return {
    classes,
  };
};
export { useStyle };
